import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    shouldComponentUpdate(nextProps) {
        if (nextProps.order_uuid != this.props.order_uuid) {
            return true;
        }

        if (
            nextProps.checkout.type != this.props.checkout.type
            &&
            (nextProps.checkout.type == 'drts' || this.props.checkout.type == 'drts')
        ) {
            return true;
        }


        return false;
    }

    render({ checkout, order_uuid, mode }) {
        if (checkout && checkout.order && !checkout.order.finalized && order_uuid) {
            if (
                mode != 'drt'
                ||
                this.props.checkout.type == 'drts'
                ||
                this.props.user.kcs.total < this.props.product.price.kc.current
            ) {
                return (
                    <paypal mode={mode}>
                        <row className='is-justified-center'>
                            <column className='is-5 is-12-mobile has-padding-30-top'>
                                <a href='#' onClick={this.checkoutPayPal}>
                                    <img
                                        src='https://gfx.tarot.com/images/checkout/2020/paypalbutton.png'
                                        alt='Checkout with PayPal'
                                    />
                                </a>
                            </column>
                        </row>
                    </paypal>
                );
            }
        }

        return (<paypal mode={mode} />);
    }

    checkoutPayPal = (e) => {
        e.preventDefault();
        this.props.checkoutPayPal({
            order_uuid: this.props.order_uuid,
            type: this.props.checkout.type,
            package: this.props.checkout.package,
        });
    }
}

const mapStateToProps = (state) => ({
    checkout: state.checkout,
    order_uuid: state.checkout && state.checkout.order && state.checkout.order.order_uuid,
    user: state.user,
    product: state.product,
});

const mapDispatchToProps = (dispatch) => ({
    checkoutPayPal: (payload) => dispatch({ type: 'checkout:paypal', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);